import { PropTypes, Component } from 'react'
import { userNextServices } from 'utils/paths'

class Service extends Component {
  componentWillUpdate (nextProps, nextState) {
    this.redirectIfServiceIsCancelled(nextProps)
  }

  redirectIfServiceIsCancelled ({ service, replace }) {
    const CANCELLED_STATUSES = [
      'cancelled'
    ]

    const serviceIsCancelled = service && CANCELLED_STATUSES.includes(service.status)

    if (serviceIsCancelled) {
      const next = userNextServices(this.props.params.userId)
      replace(next)
    }
  }

  render () {
    return this.props.children
  }
}
Service.displayName = 'Service'
Service.propTypes = {
  service: PropTypes.object,
  replace: PropTypes.func.isRequired
}

export default Service



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/Service/Service.js